module.exports = __webpack_public_path__ + "../resources/images/ribbon_sprite-dc7eaf4ad52000c2a1ab2be32c98234a.png";